import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStorageItem } from "../utilities/storageManager";

export const loadCartFromStorage = createAsyncThunk(
    // async thunk function (= returns function [not object] that performs async operation and then dispatches action ie updates store) 
    // fetches cart data from storage and returns it
    // async to ensure store loads before rendering app
    "cart/loadCartFromStorage", 
    () => {
        return getStorageItem("cart")
    }
)

const initialState = {
    cartItems: {},      
    quantity: 0,        //total nr of items
}

export const cartSlice = createSlice({
    name: "cart", 
    initialState: JSON.parse(JSON.stringify(initialState)), 
    reducers: {
        addToCart: (state, action) => {
            // cartItems: { prod1: {count:5} , ...}    quantity: #
            const {productId, count} = action.payload;
            //if item already in cartItems, just add to item count
            if(state.cartItems[productId]){
                state.cartItems[productId].count += count; 
            } else { //add as new item
                state.cartItems[productId] = {count: count};
            }
            state.quantity += count;  
        },
        deleteFromCart: (state, action) => {
            const productId = action.payload;
            if(state.cartItems[productId]){
                const count = state.cartItems[productId].count; 
                delete state.cartItems[productId];
                state.quantity -= count; 
            } 
        },
        updateCartQuantity: (state, action) => {
            const {productId, count} = action.payload; 
            if(state.cartItems[productId] && count >= 0){
                const oldCount = state.cartItems[productId].count; 
                    state.cartItems[productId].count = count; 
                if(count > oldCount){
                    state.quantity = state.quantity + (count-oldCount)
                } else {
                    state.quantity = state.quantity - (oldCount - count); 
                }
            }
        },
        clearCart: (state, action) => {
            return JSON.parse(JSON.stringify(initialState)); 
        } 
    },
  //   define action for outcome of async thunk
  extraReducers: (builder) => {
    builder
    .addCase(loadCartFromStorage.fulfilled, (state, action) => {
        if(action.payload) {
            state.cartItems = action.payload.cartItems || {...initialState.cartItems};
            state.quantity = action.payload.quantity || initialState.quantity;
        }
    })
    .addCase(loadCartFromStorage.rejected, (state, action) => {
        return JSON.parse(JSON.stringify(initialState)); 
    })
  },
})


//export (reducer function + action creator + action)
export const { addToCart, deleteFromCart, clearCart, updateCartQuantity } = cartSlice.actions;
//export reducer
export default cartSlice.reducer;
